export { default } from './LogosCarousel';